import Layout from './Layout';
import Hero from './Hero';
import RelatedGuides from './RelatedGuides';

/**
 * The Phase 2 (hydrated) /search/{slug} page tree. Rendered by BOTH sides that must
 * agree for hydration to succeed without mismatches: entry-server.jsx (server, values
 * passed as explicit args) and SearchPage.jsx (client route, values read from the
 * embedded __INITIAL_DATA__ script tag). Kept as one component - not duplicated inline
 * in each caller - specifically so the two can't drift apart from each other over time
 * (docs/seo-ssr-search-pages-design.md §7.5 bundle-drift risk).
 */
function SearchResultsPage({ searchTerm, searchResults }) {
  return (
    // titleVariant="hero": Header renders the big homepage-style brand title here
    // (Hero itself no longer draws one) - same as the "/" route in App.jsx.
    <Layout showFooter={true} titleVariant="hero">
      <Hero initialSearchTerm={searchTerm} initialSearchResults={searchResults} />
      <RelatedGuides searchTerm={searchTerm} />
    </Layout>
  );
}

export default SearchResultsPage;
